/**
 * ShoppingAgentProvider isolates the Google Shopping Agent FSM from
 * UserContextProvider so that FSM phase transitions (Idle → Clearing →
 * Cooldown → Idle) do not trigger re-renders of UserContextProvider or
 * any of its consumers.
 *
 * @module providers/ShoppingAgentProvider/ShoppingAgentProvider
 */
import React, { createContext, useContext, useState } from 'react';

import { useGoogleShoppingAgent } from '../../hooks/useGoogleShoppingAgent/useGoogleShoppingAgent';

export const ShoppingAgentContext = createContext( {
  processShoppingAgentSideEffect: () => {},
  isShoppingAgentSiteWideToggleEnabled: false,
  setShoppingAgentSiteWideToggleEnabled: () => {}
} );

export const useShoppingAgentContext = () => useContext( ShoppingAgentContext );

export const ShoppingAgentProvider = function( { children } ){
  const { processShoppingAgentSideEffect } = useGoogleShoppingAgent();

  const [isShoppingAgentSiteWideToggleEnabled, setShoppingAgentSiteWideToggleEnabled] = useState( false );

  return (
    <ShoppingAgentContext.Provider
      value={ {
        processShoppingAgentSideEffect,
        isShoppingAgentSiteWideToggleEnabled,
        setShoppingAgentSiteWideToggleEnabled
      } }
    >
      { children }
    </ShoppingAgentContext.Provider>
  );
};

export default ShoppingAgentProvider;
